import { type FC } from 'react';

import type { IExercise } from '@shared/types';

import styles from './ExerciseGuide.module.css';

interface ExerciseGuideProps {
  /** id позиции — для уникальных id заголовков */
  id: string;
  exercises: readonly IExercise[];
  safetyNote?: string;
  /** Есть ли видео под инструкцией — от этого зависит метка «На видео ниже» */
  hasVideo: boolean;
}

/** Блок «Инструкция по выполнению упражнений» в карточке позиции */
export const ExerciseGuide: FC<ExerciseGuideProps> = ({ id, exercises, safetyNote, hasVideo }) => {
  const titleId = `exercises-${id}`;

  return (
    <section className={styles.root} aria-labelledby={titleId}>
      <h2 className={styles.title} id={titleId}>
        Инструкция по выполнению упражнений
      </h2>
      <ol className={styles.list} role="list">
        {exercises.map((exercise) => (
          <li className={styles.exercise} key={exercise.title}>
            <div className={styles.head}>
              <h3 className={styles.exerciseTitle}>{exercise.title}</h3>
              {hasVideo && exercise.inVideo && (
                <span className={styles.videoMark}>На видео ниже</span>
              )}
            </div>

            <div className={styles.part}>
              <h4 className={styles.partLabel}>Исходное положение</h4>
              <p className={styles.text}>{exercise.start}</p>
            </div>

            <div className={styles.part}>
              <h4 className={styles.partLabel}>Выполнение</h4>
              <ol className={styles.steps}>
                {exercise.steps.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            </div>

            {exercise.tips && exercise.tips.length > 0 && (
              <div className={styles.part}>
                <h4 className={styles.partLabel}>Рекомендации</h4>
                <ul className={styles.tips}>
                  {exercise.tips.map((tip) => (
                    <li key={tip}>{tip}</li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ol>

      {safetyNote && <p className={styles.note}>{safetyNote}</p>}
    </section>
  );
};
